import OmniApiClient from "./base";

export const plentyCredentialsApi = {
  // Credentials management
  getCredentials: () => {
    return OmniApiClient.get("/plenty/credentials/");
  },

  createCredential: (data) => {
    return OmniApiClient.post("/plenty/credentials/", data);
  },

  deleteCredential: (credentialId) => {
    return OmniApiClient.delete(`/plenty/credentials/${credentialId}`);
  },

  updateCredential: (credentialId, data) => {
    return OmniApiClient.put(`/plenty/credentials/${credentialId}`, data);
  },

  toggleActiveCredential: (credentialId) => {
    return OmniApiClient.post(
      `/plenty/credentials/${credentialId}/toggle-active`,
    );
  },

  testCredential: (data) => {
    return OmniApiClient.post(`/plenty/credentials/test`, data);
  },
};
